module.exports = __webpack_public_path__ + "img/2.318ff389.png";